module.exports = __webpack_public_path__ + "static/media/selectedLandscape.42919319.svg";